import buildReducer from "./build-reducer";
import { GAME_BOARD_TOGGLE_RACE } from "../actions/ui";
import { Map } from "immutable";
import { PAGE_TRANSITIONING } from "../actions/session";

let reducers = {};

reducers[GAME_BOARD_TOGGLE_RACE] = (state, { raceId }) => {
  var updater = oldRaceId => oldRaceId === raceId ? undefined : raceId;
  return state.updateIn(["gameBoard", "expandedRace"], updater);
};
reducers[PAGE_TRANSITIONING] = (state) => {
  return state.deleteIn(["gameBoard", "expandedRace"]);
};

export default buildReducer(Map(), reducers);
